import { render, staticRenderFns } from "./MineHead.vue?vue&type=template&id=0ae07773&scoped=true"
import script from "./MineHead.vue?vue&type=script&lang=js"
export * from "./MineHead.vue?vue&type=script&lang=js"
import style0 from "./MineHead.vue?vue&type=style&index=0&id=0ae07773&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae07773",
  null
  
)

export default component.exports